// extracted by mini-css-extract-plugin
export default {"playButtonWrapper":"playButton-module__playButtonWrapper___lGaAP","playButton":"playButton-module__playButton___D2_0q"};